import { Controller } from "@hotwired/stimulus"

// Simple controller to initialize select2 with tags support
export default class extends Controller {
  static values = {
    tags: { type: Boolean, default: true },
    placeholder: { type: String, default: "" }
  }

  connect() {
    this.initSelect2()
  }

  disconnect() {
    if ($(this.element).data('select2')) {
      $(this.element).select2('destroy')
    }
  }

  initSelect2() {
    $(this.element).select2({
      tags: this.tagsValue,
      width: "100%",
      placeholder: this.placeholderValue
    })
  }
}
